import { FancySharePublicDto } from '@diritto/common/fancyShare/dtos/fancy-share.dtos';
import { ImageTransformOptions, ImageTransformType } from '@diritto/common/imageKit/constants';
import { ProfileLitePublicRelayDto } from '@diritto/common/relay/dtos/profile-lite-relay.dtos';
import { Color } from '@diritto/common/style/color';
import { FontWeight, Typography } from '@diritto/common/style/typography';
import styled from '@emotion/styled';
import { ProfileImage } from 'app-components/accounts/profiles/ProfileImage';
import React from 'react';
import { getTextLineStyle } from 'styles/common';
import { Link } from 'ui-components/common/Link';
import { IkImage } from 'ui-components/Imagekit/IkImage';

type SectionFancyShareItemProps = {
  fancyShare: FancySharePublicDto;
  profile: ProfileLitePublicRelayDto;
  height: number;
  onClick: () => void;
};

export const SectionFancyShareItem = ({ fancyShare, profile, height, onClick }: SectionFancyShareItemProps) => {
  const link = `/fancy-shares/${fancyShare.id}`;

  return (
    <StyledFancyShareWrapper height={height} onClick={onClick}>
      <StyledImageLink href={link}>
        <StyledImageWrapper backgroundColor={Color.Gray200}>
          <StyledIkImage
            transform={{
              path: fancyShare.file.path,
              isPrivate: fancyShare.file.isPrivate,
              transformation: ImageTransformOptions[ImageTransformType.FancyShare],
            }}
            alt={fancyShare.description}
            fullWidth
          />
        </StyledImageWrapper>
      </StyledImageLink>
      {profile && (
        <StyledProfileLink href={`/accounts/profiles/${profile.id}`}>
          <StyledProfileImage file={profile.profileImage} defaultImageKey={profile.nickname} size={24} />
          <StyledProfileNickname>{profile.nickname}</StyledProfileNickname>
        </StyledProfileLink>
      )}
    </StyledFancyShareWrapper>
  );
};

const StyledFancyShareWrapper = styled.div<{ height: number }>`
  width: 346px;
  height: ${({ height }) => height}px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const StyledProfileLink = styled(Link)`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
`;

const StyledProfileImage = styled(ProfileImage)`
  flex-shrink: 0;
`;

const StyledProfileNickname = styled.div`
  flex-shrink: 1;
  color: ${Color.Black};
  ${Typography.XXXSmall};
  font-weight: ${FontWeight.Medium};
  ${getTextLineStyle(1)};
`;

const StyledImageLink = styled(Link)`
  display: flex;
  align-items: center;
  width: 100%;
`;

const StyledIkImage = styled(IkImage)`
  border-radius: 4px;
  aspect-ratio: 1 / 1;
`;

const StyledImageWrapper = styled.div<{ backgroundColor?: string }>`
  width: 100%;
  display: flex;
  background-color: ${({ backgroundColor = Color.White }) => backgroundColor};
`;
